import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export function createSubtaskFormStyles({
  spacing,
  typography,
  palette,
}: Theme) {
  return {
    header: css({
      margin: spacing([2, 0]),
      fontWeight: typography.fontWeight.medium,
    }),
    text: css({
      lineHeight: 1.5,
      marginBottom: spacing(2),
    }),
    label: css({
      fontSize: typography.fontSize.default,
      color: palette.secondary.textDark,
      padding: spacing([1, 0]),
    }),
    form: css({
      marginTop: spacing(2),
    }),
    textArea: css({
      minHeight: 130,
      padding: spacing(2),
    }),
  };
}
